const OverNights = () => {
    return (
      <div>
      <div id="overnight" className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Overnight Express
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              This service delivers the shipments the day after TCS receives them. Covering 90% of destinations 
              on TCS network, the shipments are delivered in daylight. Customers can call to have their shipments 
              picked up or bring them over to an Express Centre themselves.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center ">
            <img src="/DomesticScrollingBanner/scrolling-image1.jpg" alt="" className="w-[100%] rounded-md sm:mt-[0rem] mt-[1rem]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default OverNights;